import { render, staticRenderFns } from "./ScoreMark.vue?vue&type=template&id=09e93ba8&scoped=true"
import script from "./ScoreMark.vue?vue&type=script&lang=js"
export * from "./ScoreMark.vue?vue&type=script&lang=js"
import style0 from "./ScoreMark.vue?vue&type=style&index=0&id=09e93ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e93ba8",
  null
  
)

export default component.exports